import { Checkbox, Space } from "antd";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { Question } from "@types";

interface Props {
  question: Question;
}

export const MultipleChoiceOption = ({question}: Props) => {

  const [checkedList, setCheckedList] = useState<string[]>(question?.playerAnswers?.map((item) => item.id) || []);

  useEffect(() => {
    if (question) {
      setCheckedList(question.playerAnswers?.map((item) => item.id) || []);
    }
  }, [question])

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 1 }}
    >
      <Checkbox.Group value={checkedList} >
      <Space direction="vertical">
        {question?.answers.map((answer, index) => (
          <Checkbox
            value={answer.id} key={index}
            style={{
              color: answer.isCorrect ? "green" : checkedList.includes(answer.id) ? "red" : "unset",
              fontWeight: answer.isCorrect ? "bold" : checkedList.includes(answer.id) ? "bold" : "normal",
            }}
          >
            {answer.value}
          </Checkbox>
        ))}
      </Space>
      </Checkbox.Group>
    </motion.div>
  );
};
